import EmailIcon from "@mui/icons-material/Email"
import Box from "@mui/material/Box"
import Paper from "@mui/material/Paper"
import Typography from "@mui/material/Typography"

export default function SignupSuccessful() {
  return (
    <Paper
      sx={{
        padding: (theme) => theme.spacing(4),
        mt: (theme) => theme.spacing(4),
      }}
    >
      <Box sx={{ textAlign: "center" }}>
        <EmailIcon
          color="primary"
          fontSize="large"
          sx={{ transform: "rotate(-10deg)" }}
        />
      </Box>
      <Typography
        variant="h5"
        textAlign="center"
        sx={{ mt: (theme) => theme.spacing(1) }}
      >
        Thank you for signing up!
      </Typography>
      <Typography
        variant="body1"
        textAlign="center"
        sx={{ mt: (theme) => theme.spacing(2) }}
      >
        Please check your email for further instructions
      </Typography>
    </Paper>
  )
}
